module.exports = __webpack_public_path__ + "media/images/icons/phone-184e0a82e03f2433aae8b8615296a26b.png";